<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" previous-disabled :title="$t('Intestazione')">
    <wizard-question :title="$t('A chi vuoi intestare il preventivo?')">
      <pf-toggle-group>
        <pf-toggle-group-item :selected="wizard.fatturaMe === true" @click="wizard.fatturaMe = true" data-ouia-component-id="invoice-me-toggle"><user-icon /> {{ $t('Direttamente me') }}</pf-toggle-group-item>
        <pf-toggle-group-item :selected="wizard.fatturaMe === false" @click="wizard.fatturaMe = false" data-ouia-component-id="invoice-customer-toggle"><users-icon /> {{ $t('Ad un mio cliente') }}</pf-toggle-group-item>
      </pf-toggle-group>
    </wizard-question>

    <wizard-question v-if="!wizard.fatturaMe" :title="$t('A quale cliente vuoi intestare il preventivo?')">
      <pf-empty-state v-if="!ready">
        <pf-empty-state-header :title="$t('Stiamo caricando la tua lista clienti...')" heading-level="h4">
          <template #icon>
            <pf-empty-state-icon>
              <pf-spinner />
            </pf-empty-state-icon>
          </template>
        </pf-empty-state-header>
        <pf-empty-state-body>
          {{ $t('Ancora pochi istanti e potrai continuare il tuo preventivo.') }}
        </pf-empty-state-body>
      </pf-empty-state>

      <template
        v-else-if="wizard.customers.length > 0"
        v-for="c of wizard.customers" :key="c.id"
      >
        <pf-radio
          :label="c.ragione_sociale"
          name="idClienteFinale"
          required
          :value="c.id"
          :checked="wizard.customer?.id === c.id"
          @change="wizard.idClienteFinale = Number(($event.target as HTMLInputElement).value)"
          :ouia-id="`wizard-select-customer-id-${c.id}`"
        />
      </template>

      <div v-if="ready && !wizard.customers.length">
        {{ $t('Nessun cliente trovato, clicca sul pulsante qui sotto per inserire un nuovo prospect') }}
        <input type="text" required style="display: none">
      </div>
    </wizard-question>

    <template v-if="!wizard.fatturaMe">
      <pf-button
        @click="openFromProspect = true"
        class="pf-v6-u-mt-md"
        data-ouia-component-id="new-prospect-button"
        style="max-width: 300px"
      >
        {{ $t("Crea un'azienda prospect") }}
      </pf-button>
      <pf-modal
        v-if="openFromProspect"
        v-model:open="openFromProspect"
        :title="$t('Inserisci un nuovo prospect')"
        variant="medium"
      >
        <form-prospect :key="formKey" v-model:id-prospect="wizard.idClienteFinale" modal @submit="refreshCustomers" />
      </pf-modal>
    </template>

    <wizard-question v-if="wizard.fatturaMe" :title="$t('Si tratta di un\'offerta di prodotti da rivendere a un cliente finale?')">
      <pf-radio
        :label="$t('Sì')"
        name="not_for_resale"
        required
        id="not_for_resale_true"
        :value="false"
        :checked="!wizard.notForResale"
        @change="wizard.notForResale = false"
      />
      <pf-radio
        :label="$t('No: da attivare per uso interno (not for resale)')"
        name="not_for_resale"
        required
        id="not_for_resale_false"
        :value="true"
        :checked="wizard.notForResale"
        @change="wizard.notForResale = true"
      />
    </wizard-question>

    <pf-flex>
      <pf-flex-item>
        <wizard-question v-if="wizard.askTest" :title="$t('Vuoi attivare questo servizio in prova per 30 giorni?')">
          <pf-switch
            v-model:checked="wizard.freePeriod"
            :value="true"
            off-value="0"
            :label="wizard.freePeriod ? $t('Sì') : $t('No')"
          />
        </wizard-question>
      </pf-flex-item>
      <pf-flex-item>
        <wizard-question v-if="wizard.freePeriod" :title="$t('Cosa vuoi fare al termine del test?')">
          <pf-radio
            :label="$t('Rinnova dopo il periodo gratuito')"
            name="renew_after_free_period"
            :value="true"
            :checked="wizard.renewAfterFreePeriod"
            @change="wizard.renewAfterFreePeriod = true"
          />
          <pf-radio
            :label="$t('Disdici dopo il periodo gratuito')"
            name="renew_after_free_period"
            :value="false"
            :checked="wizard.renewAfterFreePeriod === false"
            @change="wizard.renewAfterFreePeriod = false"
          />
        </wizard-question>
      </pf-flex-item>
    </pf-flex>

  </wizard-form>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '../composition';
import FormProspect from '../../form-prospect.vue';
import WizardForm from '../wizard-form.vue';
import WizardQuestion from '../questions/wizard-question.vue';
import UserIcon from '@vue-patternfly/icons/user-icon';
import UsersIcon from '@vue-patternfly/icons/users-icon';

defineOptions({
  name: 'WizardStepClienti',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => true,
});

const openFromProspect =ref(false);
const formKey =ref(0); // utilizzata per effettuare il reset del form

const ready = computed(() => wizard.customersState.state === 'success');

function refreshCustomers() {
  formKey.value += 1;
  wizard.customersState.update();
  openFromProspect.value = false;
}

defineExpose({
  isEnabled,
});
</script>
